interface Props {
  message?: string
}

export const LoadingMessage = ({ message = "Loading…" }: Props) => {
  return <div className="mt-4 flex w-full animate-pulse items-center gap-x-2 text-gray-600">{message}</div>
}
